import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { DropdownMenuItem } from '~/components/ui/dropdown-menu'

/**
 * L'entrée « Centre d'aide » des menus utilisateur (#78), partagée par le menu
 * du back-office et celui de l'espace apprenant. Le formulaire de contact (#81)
 * s'ouvre depuis le centre d'aide, pas depuis le menu : une seule porte d'entrée.
 * `helpPath` : le centre d'aide du cadre où se trouve le menu.
 */
function HelpMenuItems({ helpPath }: { helpPath: string }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <DropdownMenuItem onClick={() => navigate(helpPath)} className="cursor-pointer">
      <CircleHelp className="mr-2 size-4" />
      <span>{t('help.title')}</span>
    </DropdownMenuItem>
  )
}

export default HelpMenuItems
